import * as THREE from 'three';
import { GifReader } from 'omggif';

const W = 12.4;
const FRAME_DEPTH = 0.12;
const FRAME_PROFILE = 0.1;

export class ArtworkManager {
    constructor(scene, textureLoader) {
        this.scene = scene;
        this.textureLoader = textureLoader;
        this.animatedTextures = [];
        this.frameMat = new THREE.MeshStandardMaterial({ color: 0xb8963e, roughness: 0.35, metalness: 0.4 });
        this.artworks = [
            // Ground floor - Back wall (4 landscape)
            { url: '/assets/Images/artwork-1.jpg', width: 4.2, height: 2.8, position: { x: -6.5, y: 3, z: -W }, rotation: 0 },
            { url: '/assets/Images/artwork-2.jpg', width: 4.2, height: 2.8, position: { x: -2.2, y: 3, z: -W }, rotation: 0 },
            { url: '/assets/Images/artwork-3.jpg', width: 4.2, height: 2.8, position: { x: 2.2, y: 3, z: -W }, rotation: 0 },
            { url: '/assets/Images/artwork-4.GIF', width: 4.2, height: 2.8, position: { x: 6.5, y: 3, z: -W }, rotation: 0 },
            // Ground floor - Left wall (4 portrait)
            { url: '/assets/Images/artwork-5.GIF', width: 2.8, height: 4.2, position: { x: -W, y: 3, z: -6.5 }, rotation: Math.PI / 2 },
            { url: '/assets/Images/artwork-6.jpg', width: 2.8, height: 4.2, position: { x: -W, y: 3, z: -2.2 }, rotation: Math.PI / 2 },
            { url: '/assets/Images/artwork-7.jpg', width: 2.8, height: 4.2, position: { x: -W, y: 3, z: 2.2 }, rotation: Math.PI / 2 },
            { url: '/assets/Images/artwork-8.jpg', width: 2.8, height: 4.2, position: { x: -W, y: 3, z: 6.5 }, rotation: Math.PI / 2 },
            // Ground floor - Right wall (4 portrait)
            { url: '/assets/Images/artwork-9.jpg', width: 2.8, height: 4.2, position: { x: W, y: 3, z: -6.5 }, rotation: -Math.PI / 2 },
            { url: '/assets/Images/artwork-10.jpg', width: 2.8, height: 4.2, position: { x: W, y: 3, z: -2.2 }, rotation: -Math.PI / 2 },
            { url: '/assets/Images/artwork-11.GIF', width: 2.8, height: 4.2, position: { x: W, y: 3, z: 2.2 }, rotation: -Math.PI / 2 },
            { url: '/assets/Images/artwork-12.jpg', width: 2.8, height: 4.2, position: { x: W, y: 3, z: 6.5 }, rotation: -Math.PI / 2 },
            // Ground floor - Front wall (2 landscape, one per wall segment flanking entrance)
            { url: '/assets/Images/artwork-13.jpg', width: 4.2, height: 2.8, position: { x: -9.5, y: 3, z: W }, rotation: Math.PI },
            { url: '/assets/Images/artwork-14.jpg', width: 4.2, height: 2.8, position: { x: 9.5, y: 3, z: W }, rotation: Math.PI },
            // Second floor - Back wall (4 landscape)
            { url: '/assets/Images/artwork-17.jpg', width: 4.2, height: 2.8, position: { x: -6.5, y: 9, z: -W }, rotation: 0 },
            { url: '/assets/Images/artwork-18.jpg', width: 4.2, height: 2.8, position: { x: -2.2, y: 9, z: -W }, rotation: 0 },
            { url: '/assets/Images/artwork-19.jpg', width: 4.2, height: 2.8, position: { x: 2.2, y: 9, z: -W }, rotation: 0 },
            { url: '/assets/Images/artwork-20.jpg', width: 4.2, height: 2.8, position: { x: 6.5, y: 9, z: -W }, rotation: 0 },
            // Second floor - Left wall (4 portrait, slot 4 uses freed artwork-15)
            { url: '/assets/Images/artwork-21.GIF', width: 2.8, height: 4.2, position: { x: -W, y: 9, z: -6.5 }, rotation: Math.PI / 2 },
            { url: '/assets/Images/artwork-22.jpg', width: 2.8, height: 4.2, position: { x: -W, y: 9, z: -2.2 }, rotation: Math.PI / 2 },
            { url: '/assets/Images/artwork-23.GIF', width: 2.8, height: 4.2, position: { x: -W, y: 9, z: 2.2 }, rotation: Math.PI / 2 },
            { url: '/assets/Images/artwork-15.jpg', width: 2.8, height: 4.2, position: { x: -W, y: 9, z: 6.5 }, rotation: Math.PI / 2 },
            // Second floor - Right wall (4 portrait, slot 4 uses freed artwork-16)
            { url: '/assets/Images/artwork-24.GIF', width: 2.8, height: 4.2, position: { x: W, y: 9, z: -6.5 }, rotation: -Math.PI / 2 },
            { url: '/assets/Images/artwork-25.jpg', width: 2.8, height: 4.2, position: { x: W, y: 9, z: -2.2 }, rotation: -Math.PI / 2 },
            { url: '/assets/Images/artwork-26.GIF', width: 2.8, height: 4.2, position: { x: W, y: 9, z: 2.2 }, rotation: -Math.PI / 2 },
            { url: '/assets/Images/artwork-16.jpg', width: 2.8, height: 4.2, position: { x: W, y: 9, z: 6.5 }, rotation: -Math.PI / 2 },
            // Second floor - Front wall (2 landscape, flanking entrance)
            { url: '/assets/Images/artwork-27.GIF', width: 4.2, height: 2.8, position: { x: -9.5, y: 9, z: W }, rotation: Math.PI },
            { url: '/assets/Images/artwork-28.jpg', width: 4.2, height: 2.8, position: { x: 9.5, y: 9, z: W }, rotation: Math.PI },
        ];
    }

    createFrame(w, h, pos, rot) {
        const g = new THREE.Group();
        const p = FRAME_PROFILE;
        const d = FRAME_DEPTH;
        const box = (sx, sy, sz, px, py, pz) => {
            const m = new THREE.Mesh(new THREE.BoxGeometry(sx, sy, sz), this.frameMat);
            m.position.set(px, py, pz);
            g.add(m);
        };
        box(w + p * 2, p, d, 0, h / 2 + p / 2, 0);
        box(w + p * 2, p, d, 0, -h / 2 - p / 2, 0);
        box(p, h, d, -w / 2 - p / 2, 0, 0);
        box(p, h, d, w / 2 + p / 2, 0, 0);

        const fixtureMat = new THREE.MeshStandardMaterial({
            color: 0xc4a87c, metalness: 0.6, roughness: 0.25,
            emissive: 0xffddaa, emissiveIntensity: 0.8
        });
        const bar = new THREE.Mesh(new THREE.BoxGeometry(w * 0.45, 0.05, 0.08), fixtureMat);
        bar.position.set(0, h / 2 + p + 0.06, 0.12);
        bar.rotation.x = -0.4;
        g.add(bar);
        const armMat = new THREE.MeshStandardMaterial({ color: 0xc4a87c, metalness: 0.5, roughness: 0.3 });
        const arm = new THREE.Mesh(new THREE.BoxGeometry(0.04, 0.15, 0.04), armMat);
        arm.position.set(0, h / 2 + p + 0.02, 0.02);
        g.add(arm);

        g.position.set(pos.x, pos.y, pos.z);
        g.rotation.y = rot;
        this.scene.add(g);
    }

    loadArtworks() {
        this.artworks.forEach(art => {
            const isGif = art.url.toLowerCase().endsWith('.gif');
            const filename = art.url.split('/').pop();

            this.createFrame(art.width, art.height, art.position, art.rotation);

            if (isGif) {
                fetch(art.url)
                    .then(r => r.arrayBuffer())
                    .then(buf => {
                        const reader = new GifReader(new Uint8Array(buf));
                        const gw = reader.width, gh = reader.height;
                        const frameCount = reader.numFrames();
                        const compCanvas = document.createElement('canvas');
                        compCanvas.width = gw;
                        compCanvas.height = gh;
                        const compCtx = compCanvas.getContext('2d');
                        compCtx.fillStyle = '#fff';
                        compCtx.fillRect(0, 0, gw, gh);
                        const tmpCanvas = document.createElement('canvas');
                        tmpCanvas.width = gw;
                        tmpCanvas.height = gh;
                        const tmpCtx = tmpCanvas.getContext('2d');
                        const frames = [];
                        const delays = [];
                        let prevDisposal = 0;
                        let prevInfo = null;
                        for (let i = 0; i < frameCount; i++) {
                            const info = reader.frameInfo(i);
                            delays.push(Math.max(info.delay || 10, 2) * 10);
                            if (i > 0 && prevDisposal === 2 && prevInfo) {
                                compCtx.fillStyle = '#fff';
                                compCtx.fillRect(prevInfo.x, prevInfo.y, prevInfo.width, prevInfo.height);
                            }
                            const rawPixels = new Uint8ClampedArray(gw * gh * 4);
                            reader.decodeAndBlitFrameRGBA(i, rawPixels);
                            tmpCtx.clearRect(0, 0, gw, gh);
                            tmpCtx.putImageData(new ImageData(rawPixels, gw, gh), 0, 0);
                            compCtx.drawImage(tmpCanvas, 0, 0);
                            frames.push(compCtx.getImageData(0, 0, gw, gh));
                            prevDisposal = info.disposal;
                            prevInfo = info;
                        }
                        const canvas = document.createElement('canvas');
                        canvas.width = gw;
                        canvas.height = gh;
                        const ctx = canvas.getContext('2d');
                        ctx.putImageData(frames[0], 0, 0);
                        const texture = new THREE.CanvasTexture(canvas);
                        texture.colorSpace = THREE.SRGBColorSpace;
                        const mesh = new THREE.Mesh(
                            new THREE.PlaneGeometry(art.width, art.height),
                            new THREE.MeshBasicMaterial({ map: texture, side: THREE.FrontSide })
                        );
                        mesh.position.set(art.position.x, art.position.y, art.position.z);
                        mesh.rotation.y = art.rotation;
                        this.scene.add(mesh);
                        this.animatedTextures.push({
                            texture, ctx, frames, delays,
                            currentFrame: 0, lastTime: performance.now()
                        });
                    })
                    .catch(err => console.warn(`Failed to load GIF: ${filename}`, err));
            } else {
                this.textureLoader.load(
                    art.url,
                    (texture) => {
                        texture.colorSpace = THREE.SRGBColorSpace;
                        const mesh = new THREE.Mesh(
                            new THREE.PlaneGeometry(art.width, art.height),
                            new THREE.MeshBasicMaterial({ map: texture, side: THREE.FrontSide })
                        );
                        mesh.position.set(art.position.x, art.position.y, art.position.z);
                        mesh.rotation.y = art.rotation;
                        this.scene.add(mesh);
                    },
                    undefined,
                    (error) => console.warn(`Failed to load artwork: ${filename}`, error)
                );
            }
        });
    }
}
